import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CampaignAccessLandingPage from "./CampaignAccessLandingPage";

const PUBLIC_FALLBACK = "Campaign secure access is temporarily unavailable.";

export const isCampaignAccessPath = (pathname) =>
  pathname === "/campaign-access" || pathname === "/campaign-access/";

export class CampaignAccessErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="min-h-screen bg-slate-100 px-4 py-12">
          <section
            className="mx-auto max-w-xl rounded-xl border border-red-200 bg-white p-7"
            aria-labelledby="campaign-access-error-title"
          >
            <h1
              id="campaign-access-error-title"
              className="text-2xl font-semibold text-slate-900"
            >
              Secure Campaign Access
            </h1>
            <p className="mt-4 text-sm text-red-700" role="alert">
              {PUBLIC_FALLBACK}
            </p>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}

export default function CampaignAccessPublicShell() {
  return (
    <CampaignAccessErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/campaign-access"
            element={<CampaignAccessLandingPage />}
          />
          <Route
            path="/campaign-access/"
            element={<CampaignAccessLandingPage />}
          />
        </Routes>
      </BrowserRouter>
    </CampaignAccessErrorBoundary>
  );
}
